var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-reviews-fit-rating.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "review"),"SecondaryRatings"]));
frame.set("fitRating", t_1, true);
if(frame.topLevel) {
context.setVariable("fitRating", t_1);
}
if(frame.topLevel) {
context.addExport("fitRating", t_1);
}
output += "\n\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "fitRating")),"fitSlide")) {
var t_2;
t_2 = "fitSlide";
frame.set("fitRatingType", t_2, true);
if(frame.topLevel) {
context.setVariable("fitRatingType", t_2);
}
if(frame.topLevel) {
context.addExport("fitRatingType", t_2);
}
output += "\n";
;
}
else {
var t_3;
t_3 = runtime.memberLookup(((lineno = 5, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "review"),"SecondaryRatingsOrder",[""]]))),0);
frame.set("fitRatingType", t_3, true);
if(frame.topLevel) {
context.setVariable("fitRatingType", t_3);
}
if(frame.topLevel) {
context.addExport("fitRatingType", t_3);
}
output += "\n";
;
}
var t_4;
t_4 = (lineno = 8, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "fitRating"),runtime.contextOrFrameLookup(context, frame, "fitRatingType"),{}]));
frame.set("fitRatingForType", t_4, true);
if(frame.topLevel) {
context.setVariable("fitRatingForType", t_4);
}
if(frame.topLevel) {
context.addExport("fitRatingForType", t_4);
}
var t_5;
t_5 = (lineno = 9, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "fitRatingForType"),"Value"]));
frame.set("fitRatingValue", t_5, true);
if(frame.topLevel) {
context.setVariable("fitRatingValue", t_5);
}
if(frame.topLevel) {
context.addExport("fitRatingValue", t_5);
}
var t_6;
t_6 = (lineno = 10, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.thirdParty.default.bazaarvoice.fit_ratings"]));
frame.set("fitRatingSlugs", t_6, true);
if(frame.topLevel) {
context.setVariable("fitRatingSlugs", t_6);
}
if(frame.topLevel) {
context.addExport("fitRatingSlugs", t_6);
}
var t_7;
t_7 = (lineno = 11, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "fitRatingSlugs"),runtime.contextOrFrameLookup(context, frame, "fitRatingType") + "" + "[" + "" + runtime.contextOrFrameLookup(context, frame, "fitRatingValue") + "" + "]"]));
frame.set("fitRatingSlug", t_7, true);
if(frame.topLevel) {
context.setVariable("fitRatingSlug", t_7);
}
if(frame.topLevel) {
context.addExport("fitRatingSlug", t_7);
}
var t_8;
t_8 = (lineno = 12, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [runtime.contextOrFrameLookup(context, frame, "fitRatingSlug"),runtime.makeKeywordArgs({"orEmpty": runtime.contextOrFrameLookup(context, frame, "True")})]));
frame.set("localizedFitRating", t_8, true);
if(frame.topLevel) {
context.setVariable("localizedFitRating", t_8);
}
if(frame.topLevel) {
context.addExport("localizedFitRating", t_8);
}
if(runtime.contextOrFrameLookup(context, frame, "localizedFitRating")) {
output += "\n\n<p class=\"c-product-review__body-text\">\n\n    <span class=\"c-product-review__body-text--strong\">";
output += runtime.suppressValue((lineno = 18, colno = 56, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_reviews-fits-label"])), env.opts.autoescape);
output += ": </span> ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "localizedFitRating"), env.opts.autoescape);
output += "\n\n</p>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-reviews-fit-rating.j2"] , dependencies)